export const videoNodeName = 'video';
export var VideoAttr;
(function (VideoAttr) {
    VideoAttr["Service"] = "service";
    VideoAttr["VideoID"] = "videoid";
})(VideoAttr || (VideoAttr = {}));
